import { Component, inject, output } from "@angular/core";
import { IRangeToMonth } from "ev-time-period-filter";
import { MarketSalesStateService } from "src/services/estate/market-sales-state.service";
import { EvAuthorizationService } from "src/util/auth0/ev-auth.service";
import { EVServiceType } from "src/util/auth0/models/evServiceType.enum";
import { SearchFilterBuildYearComponent } from "../search-filter-buildyear/search-filter-buildyear.component";
import { BuildYearFilterModel } from "../search-filter-buildyear/search-filter-buildyear.model";
import { SearchFilterEnergyLabelsComponent } from "../search-filter-energy-labels/search-filter-energy-labels.component";
import { SearchFilterEstateTypesComponent } from "../search-filter-estate-types/search-filter-estate-types.component";
import { SearchFilterFacilitiesComponent } from "../search-filter-facilities/search-filter-facilities.component";
import { SearchFilterFloorComponent } from "../search-filter-floor/search-filter-floor.component";
import { FloorFilterModel } from "../search-filter-floor/search-filter-floor.model";
import { SearchFilterGreenHousingComponent } from "../search-filter-green-housing/search-filter-green-housing.component";
import { SearchFilterNumberOfBedroomComponent } from "../search-filter-numberofbedroom/search-filter-numberofbedroom.component";
import { NumberOfBedroomFilterModel } from "../search-filter-numberofbedroom/search-filter-numberofbedroom.model";
import { SearchFilterOwnershipComponent } from "../search-filter-ownership/search-filter-ownership.component";
import { SearchFilterPlotAreaComponent } from "../search-filter-plotarea/search-filter-plotarea.component";
import { PlotAreaFilterModel } from "../search-filter-plotarea/search-filter-plotarea.model";
import { SearchFilterPriceComponent } from "../search-filter-price/search-filter-price.component";
import { PriceFilterModel } from "../search-filter-price/search-filter-price.model";
import { SearchFilterSitetypeComponent } from "../search-filter-sitetype/search-filter-sitetype.component";
import { SearchFilterSqmPriceComponent } from "../search-filter-sqmprice/search-filter-sqmprice.component";
import { SqmPriceFilterModel } from "../search-filter-sqmprice/search-filter-sqmprice.model";
import { SearchFilterTimePeriodComponent } from "../search-filter-time-period/search-filter-time-period.component";
import { TimePeriodFilterModel } from "../search-filter-time-period/search-filter-time-period.model";
import { SearchFilterTimeOnMarketComponent } from "../search-filter-timeonmarket/search-filter-timeonmarket.component";
import { TimeOnMarketFilterModel } from "../search-filter-timeonmarket/search-filter-timeonmarket.model";
import { SearchFilterUnitAreaComponent } from "../search-filter-unitarea/search-filter-unitarea.component";
import { UnitAreaFilterModel } from "../search-filter-unitarea/search-filter-unitarea.model";
import { SearchFilterViewOptionsComponent } from "../search-filter-view-options/search-filter-view-options.component";

@Component({
    selector: "estate-filter-fields",
    imports: [
        SearchFilterPriceComponent,
        SearchFilterBuildYearComponent,
        SearchFilterSqmPriceComponent,
        SearchFilterUnitAreaComponent,
        SearchFilterTimeOnMarketComponent,
        SearchFilterNumberOfBedroomComponent,
        SearchFilterPlotAreaComponent,
        SearchFilterTimePeriodComponent,
        SearchFilterEstateTypesComponent,
        SearchFilterFloorComponent,
        SearchFilterOwnershipComponent,
        SearchFilterSitetypeComponent,
        SearchFilterFacilitiesComponent,
        SearchFilterEnergyLabelsComponent,
        SearchFilterGreenHousingComponent,
        SearchFilterViewOptionsComponent,
    ],
    templateUrl: "./estate-filter-fields.component.html",
    styleUrl: "./estate-filter-fields.component.scss",
})
export class EstateFilterFieldsComponent {
    private readonly mapStateService = inject(MarketSalesStateService);
    private readonly authService = inject(EvAuthorizationService);

    // Lets the filter bar above draw a divider once this list is scrolled away from the top.
    readonly scrolled = output<boolean>();

    private isScrolled = false;

    filterForm = this.mapStateService.filterForm;
    hasGreenHousing = this.authService.hasPermissionSignal(EVServiceType.EvWeb_GreenHome, false, false);

    onScroll(event: Event): void {
        const isScrolled = (event.target as HTMLElement).scrollTop > 0;

        if (isScrolled === this.isScrolled) return;

        this.isScrolled = isScrolled;
        this.scrolled.emit(isScrolled);
    }

    rangeToMonthListValue = [
        {
            key: 5,
            monthValue: 36,
            unitsDisplay: "år",
            unitsAmountDisplay: "3",
        },
        {
            key: 4,
            monthValue: 12,
            unitsDisplay: "år",
            unitsAmountDisplay: "1",
            initial: true,
        },
        {
            key: 3,
            monthValue: 6,
            unitsDisplay: "mnd",
            unitsAmountDisplay: "6",
        },
        {
            key: 2,
            monthValue: 3,
            unitsDisplay: "mnd",
            unitsAmountDisplay: "3",
        },
        {
            key: 1,
            monthValue: 1,
            unitsDisplay: "mnd",
            unitsAmountDisplay: "1",
        },
        {
            key: 0,
            monthValue: 1,
            unitsDisplay: "mnd",
            unitsAmountDisplay: "1",
            hide: true,
        },
    ] as IRangeToMonth[];
}

export interface EstateFilterModel {
    price: PriceFilterModel;
    buildYear: BuildYearFilterModel;
    sqmPrice: SqmPriceFilterModel;
    unitArea: UnitAreaFilterModel;
    timeOnMarket: TimeOnMarketFilterModel;
    numberOfBedroom: NumberOfBedroomFilterModel;
    floor: FloorFilterModel;
    plotArea: PlotAreaFilterModel;
    timePeriod: TimePeriodFilterModel;
}
